import Vue from 'vue'
import VueRouter from 'vue-router'

import PageViewEditorial from '../views/PageViewEditorial.vue'
import PageViewSystemGrade from '../views/PageViewSystemGrade.vue'
import Editorial from '../views/editorial/Editorial.vue'
import Editorial1 from '../views/editorial/Editorial1.vue'
import Editorial2 from '../views/editorial/Editorial2.vue'
import Editorial3 from '../views/editorial/Editorial3.vue'
import Editorial4 from '../views/editorial/Editorial4.vue'
import Editorial5 from '../views/editorial/Editorial5.vue'
import Editorial6 from '../views/editorial/Editorial6.vue'
import Editorial7 from '../views/editorial/Editorial7.vue'
import Editorial8 from '../views/editorial/Editorial8.vue'
import Editorial9 from '../views/editorial/Editorial9.vue'

import FAQ from '../views/faq/FAQ.vue'
import Referenzen from '../views/referenzen/Referenzen.vue'
import Meinungen from '../views/meinungen/Meinungen.vue'
import Medien from '../views/medien/Medien.vue'
import Impressum from '../views/impressum/Impressum.vue'
import Home from '../views/home/Home.vue'
import Kontakt from '../views/kontakt/Kontakt.vue'
import Datenschutz from '../views/datenschutz/Datenschutz.vue'

import DasSystem from '../views/system/DasSystem.vue'
import Aufbau from '../views/system/Aufbau.vue'
import Ausbilder from '../views/system/Ausbilder.vue'

import Ausbildungsgrade from '../views/system/Ausbildungsgrade.vue'

import BasicQualificationCourse from '@/views/system/BasicQualificationCourse.vue'

import Grad1Prefight from '../views/system/grad1/Grad1Prefight.vue'
import Grad1Infight from '../views/system/grad1/Grad1Infight.vue'
import Grad1Wrestling from '../views/system/grad1/Grad1Wrestling.vue'
import Grad1Grappling from '../views/system/grad1/Grad1Grappling.vue'
import Grad1Weapons from '../views/system/grad1/Grad1Weapons.vue'
import Grad1Postfight1 from '../views/system/grad1/Grad1Postfight1.vue'
import Grad1Postfight2 from '../views/system/grad1/Grad1Postfight2.vue'

import Grad2Prefight from '../views/system/grad2/Grad2Prefight.vue'
import Grad2Infight from '../views/system/grad2/Grad2Infight.vue'
import Grad2Wrestling from '../views/system/grad2/Grad2Wrestling.vue'
import Grad2Grappling from '../views/system/grad2/Grad2Grappling.vue'
import Grad2Weapons from '../views/system/grad2/Grad2Weapons.vue'
import Grad2Postfight1 from '../views/system/grad2/Grad2Postfight1.vue'

import Grad3Prefight from '../views/system/grad3/Grad3Prefight.vue'
import Grad3Infight from '../views/system/grad3/Grad3Infight.vue'
import Grad3Wrestling from '../views/system/grad3/Grad3Wrestling.vue'
import Grad3Grappling from '../views/system/grad3/Grad3Grappling.vue'
import Grad3Weapons from '../views/system/grad3/Grad3Weapons.vue'
import Grad3Postfight1 from '../views/system/grad3/Grad3Postfight1.vue'

import Grad4Prefight from '../views/system/grad4/Grad4Prefight.vue'
import Grad4Infight from '../views/system/grad4/Grad4Infight.vue'
import Grad4Wrestling from '../views/system/grad4/Grad4Wrestling.vue'
import Grad4Grappling from '../views/system/grad4/Grad4Grappling.vue'
import Grad4Weapons from '../views/system/grad4/Grad4Weapons.vue'
import Grad4Postfight1 from '../views/system/grad4/Grad4Postfight1.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/the-system-overview',
		name: 'DasSystem',
		component: DasSystem
	},
	{
		path: '/structure',
		name: 'Aufbau',
		component: Aufbau
	},
	{
		path: '/trainers',
		name: 'Ausbilder',
		component: Ausbilder
	},
	{
		path: '/training-content',
		name: 'AusbildungsgradeOverview',
		redirect: { name: 'Ausbildungsgrade' },
		component: PageViewSystemGrade,
		children: [
			{
				path: '/training-content-overview',
				name: 'Ausbildungsgrade',
				component: Ausbildungsgrade
			},
			{
				path: '/basic-qualification-course',
				name: 'BasicQualificationCourse',
				component: BasicQualificationCourse
			},
			{
				path: 'phase1-prefight',
				name: 'Grad1Prefight',
				component: Grad1Prefight
			},
			{
				path: 'phase1-infight',
				name: 'Grad1Infight',
				component: Grad1Infight
			},
			{
				path: 'phase1-wrestling',
				name: 'Grad1Wrestling',
				component: Grad1Wrestling
			},
			{
				path: 'phase1-grappling',
				name: 'Grad1Grappling',
				component: Grad1Grappling
			},
			{
				path: 'phase1-weapons',
				name: 'Grad1Weapons',
				component: Grad1Weapons
			},
			{
				path: 'phase1-postfight1',
				name: 'Grad1Postfight1',
				component: Grad1Postfight1
			},
			{
				path: 'phase1-postfight2',
				name: 'Grad1Postfight2',
				component: Grad1Postfight2
			},

			{
				path: 'phase2-prefight',
				name: 'Grad2Prefight',
				component: Grad2Prefight
			},
			{
				path: 'phase2-infight',
				name: 'Grad2Infight',
				component: Grad2Infight
			},
			{
				path: 'phase2-wrestling',
				name: 'Grad2Wrestling',
				component: Grad2Wrestling
			},
			{
				path: 'phase2-grappling',
				name: 'Grad2Grappling',
				component: Grad2Grappling
			},
			{
				path: 'phase2-weapons',
				name: 'Grad2Weapons',
				component: Grad2Weapons
			},
			{
				path: 'phase2-postfight1',
				name: 'Grad2Postfight1',
				component: Grad2Postfight1
			},
			{
				path: 'phase3-prefight',
				name: 'Grad3Prefight',
				component: Grad3Prefight
			},
			{
				path: 'phase3-infight',
				name: 'Grad3Infight',
				component: Grad3Infight
			},
			{
				path: 'phase3-wrestling',
				name: 'Grad3Wrestling',
				component: Grad3Wrestling
			},
			{
				path: 'phase3-grappling',
				name: 'Grad3Grappling',
				component: Grad3Grappling
			},
			{
				path: 'phase3-weapons',
				name: 'Grad3Weapons',
				component: Grad3Weapons
			},
			{
				path: 'phase3-postfight1',
				name: 'Grad3Postfight1',
				component: Grad3Postfight1
			},
			{
				path: 'phase4-prefight',
				name: 'Grad4Prefight',
				component: Grad4Prefight
			},
			{
				path: 'phase4-infight',
				name: 'Grad4Infight',
				component: Grad4Infight
			},
			{
				path: 'phase4-wrestling',
				name: 'Grad4Wrestling',
				component: Grad4Wrestling
			},
			{
				path: 'phase4-grappling',
				name: 'Grad4Grappling',
				component: Grad4Grappling
			},
			{
				path: 'phase4-weapons',
				name: 'Grad4Weapons',
				component: Grad4Weapons
			},
			{
				path: 'phase4-postfight1',
				name: 'Grad4Postfight1',
				component: Grad4Postfight1
			}
		]
	},

	{
		path: '/blog',
		name: 'EditorialOverview',
		redirect: { name: Editorial },
		component: PageViewEditorial,
		children: [
			{
				path: '/blog-overview',
				name: 'Editorial',
				component: Editorial
			},
			{
				path: 'blog-1',
				name: 'Editorial1',
				component: Editorial1
			},
			{
				path: 'blog-2',
				name: 'Editorial2',
				component: Editorial2
			},
			{
				path: 'blog-3',
				name: 'Editorial3',
				component: Editorial3
			},
			{
				path: 'blog-4',
				name: 'Editorial4',
				component: Editorial4
			},
			{
				path: 'blog-5',
				name: 'Editorial5',
				component: Editorial5
			},
			{
				path: 'blog-6',
				name: 'Editorial6',
				component: Editorial6
			},
			{
				path: 'blog-7',
				name: 'Editorial7',
				component: Editorial7
			},
			{
				path: 'blog-8',
				name: 'Editorial8',
				component: Editorial8
			},
			{
				path: 'blog-9',
				name: 'Editorial9',
				component: Editorial9
			}
		]
	},
	{
		path: '/faq',
		name: 'FAQ',
		component: FAQ
	},
	{
		path: '/references',
		name: 'Referenzen',
		component: Referenzen
	},
	{
		path: '/testimonials',
		name: 'Meinungen',
		component: Meinungen
	},
	{
		path: '/media',
		name: 'Medien',
		component: Medien
	},
	{
		path: '/imprint',
		name: 'Impressum',
		component: Impressum
	},
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/contact',
		name: 'Kontakt',
		component: Kontakt
	},
	{
		path: '/data-protection',
		name: 'Datenschutz',
		component: Datenschutz
	}
]
function scrollBehavior(to, from, savedPosition) {
	if (savedPosition) {
		return savedPosition
	} else {
		return { x: 0, y: 0 }
	}
}

const router = new VueRouter({
	routes,
	scrollBehavior
})

export default router
